import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "container"
  }, [_vm.tiles.length === 0 && !_vm.loading && _vm.noDataAlert ? [_c(VAlert, {
    staticClass: "mb-1",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": true,
      "color": "transparent",
      "icon": "fal fa-comment-exclamation"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n    ")])] : _vm._e(), _vm.uiComponents && !_vm.loading ? _c('div', {
    class: `preview-tile-grid${_vm.tileSizeSetting === 1 ? '-small' : ''}`,
    style: _vm.boxStyle
  }, [_vm.tiles.length === 0 && _vm.loading ? _vm._l([0, 1, 2], function (twinStateTemplateId) {
    return _c(VCard, {
      key: `state_${twinStateTemplateId}`,
      staticClass: "dtwin-card detail-card preview-card pa-2",
      attrs: {
        "outlined": "",
        "elevation": "0"
      }
    }, [_c('div', {
      staticClass: "text-caption preview-tile-center"
    }, [_c(VSkeletonLoader, {
      attrs: {
        "type": "chip"
      }
    })], 1), _c('div', {
      class: _vm.previewVisual
    }, [_c(VSkeletonLoader, {
      staticStyle: {
        "width": "80%",
        "height": "80%"
      },
      attrs: {
        "type": "image"
      }
    })], 1), _c('div', {
      staticStyle: {
        "display": "flex",
        "justify-content": "space-between"
      }
    }, [_c('div', {
      staticClass: "text-caption preview-tile-center"
    }, [_c(VSkeletonLoader, {
      attrs: {
        "type": "chip"
      }
    })], 1)])]);
  }) : _vm._e(), _vm._l(_vm.tiles, function (twinDataState) {
    return _c(VCard, {
      key: `state_${twinDataState.id}`,
      staticClass: "dtwin-card detail-card preview-card pa-2",
      style: _vm.getCompStyle(twinDataState),
      attrs: {
        "elevation": "0"
      }
    }, [_c('div', {
      staticClass: "text-caption preview-tile-center"
    }, [_c(VIcon, {
      class: _vm.color + '--text mr-1',
      attrs: {
        "small": ""
      }
    }, [_vm._v("fal fa-" + _vm._s(twinDataState.properties.faIcon))]), _c('span', {
      staticClass: "text-truncate"
    }, [_vm._v("\n          " + _vm._s(twinDataState.properties.title) + "\n          " + _vm._s((twinDataState.properties.unit || '').trim() !== '' ? `(${twinDataState.properties.unit})` : '') + "\n        ")])], 1), _c('div', {
      class: _vm.previewVisual
    }, [_vm.getComponentType(twinDataState) === 'modifier-bool' || _vm.getComponentType(twinDataState) === 'button' ? [_c('div', {
      staticClass: "text-center d-flex flex-column justify-center align-center"
    }, [_vm.isBooleanVisualisation(twinDataState) ? [_c('div', {
      staticClass: "d-flex flex-column justify-center align-center h-full"
    }, [_c(VIcon, {
      attrs: {
        "color": _vm.faIconColor(twinDataState),
        "x-large": ""
      }
    }, [_vm._v("fal fa-" + _vm._s(_vm.faIcon(twinDataState)))]), _c('p', {
      staticClass: "mt-3 max-width text-truncate",
      attrs: {
        "title": _vm.stateTitle(twinDataState)
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.stateTitle(twinDataState)) + "\n                ")])], 1)] : [_vm.getComponentType(twinDataState) === 'button' && typeof _vm.permissions !== 'undefined' && _vm.permissions['DigitalTwin.write'] ? [_c('core-button', {
      attrs: {
        "color": _vm.color,
        "prepend-icon": _vm.modifierBoolButtonIcon(twinDataState)
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.modifierBoolButtonClicked(twinDataState);
        }
      }
    })] : _vm._e(), _c('p', {
      staticClass: "mt-1 max-width text-truncate",
      attrs: {
        "title": String(_vm.get(twinDataState, 'value.value'))
      }
    }, [_vm._v("\n                " + _vm._s(String(_vm.get(twinDataState, 'value.value'))) + "\n              ")])]], 2)] : _vm.getComponentType(twinDataState) === 'gauge' ? _c('core-chart-gauge-modern', {
      attrs: {
        "min": parseFloat(twinDataState.properties.visual.options.min) || 0,
        "max": parseFloat(twinDataState.properties.visual.options.max) || 0,
        "thresholds": (twinDataState.properties.visual.options.thresholds || '').split(',').map(i => parseFloat(i)),
        "reverse": twinDataState.properties.visual.options.reverse,
        "value": parseFloat(twinDataState.value.value),
        "unit": twinDataState.properties.unit,
        "thresholdColors": twinDataState.properties.visual.options.thresColors,
        "fixTo": parseFloat(twinDataState.properties.visual.options.decimalPoints) || 0
      }
    }) : _vm.getComponentType(twinDataState) === 'doughnut' || _vm.getComponentType(twinDataState) === 'donut' ? _c('core-chart-doughnut', {
      staticClass: "pa-2",
      attrs: {
        "value": parseFloat(twinDataState.value.value)
      }
    }) : _vm.getComponentType(twinDataState) === 'odometer' ? _c('core-chart-odometer', {
      attrs: {
        "value": parseFloat(twinDataState.value.value),
        "minLength": twinDataState.properties && twinDataState.properties.visual && parseFloat(twinDataState.properties.visual.options.minimumLength) || null,
        "fixTo": twinDataState.properties && twinDataState.properties.visual && parseFloat(twinDataState.properties.visual.options.decimalPoints) || null
      }
    }) : _vm.getComponentType(twinDataState) === 'battery' ? _c('core-chart-battery', {
      attrs: {
        "value": parseFloat(twinDataState.value.value),
        "size": _vm.previewBatteryHeight
      }
    }) : _vm.getComponentType(twinDataState) === 'alarmTable' ? _c('core-chart-alarm-table', {
      attrs: {
        "size": _vm.previewAlertHeight,
        "width": 200
      }
    }) : _vm.getComponentType(twinDataState) === 'lineChart' ? _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_vm.chartLoading ? _c(VProgressCircular, {
      attrs: {
        "indeterminate": "",
        "color": _vm.vuetifyColorHex(_vm.color)
      }
    }) : _c('div', {
      staticClass: "relative"
    }, [_c('core-chart-history-state-line', {
      key: `lineChart-${twinDataState.id}_${twinDataState.lineChartId}`,
      class: {
        'chart-empty': _vm.isEmptyChart(_vm.chartDataFormated[twinDataState.id])
      },
      attrs: {
        "chart-data": _vm.chartDataFormated[twinDataState.id],
        "interval": _vm.get(twinDataState, 'properties.visual.options.interval') || _vm.interval,
        "width": 400,
        "height": _vm.tileSizeSetting === 0 ? 160 : 83,
        "config": _vm.multiChartConfig[twinDataState.id],
        "hideLegend": _vm.tileSizeSetting !== 0,
        "minYAxis": _vm.calculateAxisValue(twinDataState, 'minYAxis'),
        "maxYAxis": _vm.calculateAxisValue(twinDataState, 'maxYAxis')
      }
    }), _vm.isEmptyChart(_vm.chartDataFormated[twinDataState.id]) ? _c('div', {
      staticClass: "chart-empty-text"
    }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n            ")]) : _vm._e(), _vm.hasChartError ? _c('div', {
      staticClass: "chart-empty-text"
    }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.errorWhileFetchingData')) + "\n            ")]) : _vm._e()], 1)], 1) : _vm.getComponentType(twinDataState) === 'fittext' ? _c('core-chart-fit-text', {
      attrs: {
        "value": parseFloat(twinDataState.value.value)
      }
    }) : _vm.getComponentType(twinDataState) === 'string' ? _c('div', {
      staticClass: "preview-text-container",
      on: {
        "click": function ($event) {
          return _vm.showString(twinDataState.value.value);
        }
      }
    }, [_c('div', {
      staticClass: "preview-text text-truncate"
    }, [_vm._v("\n            " + _vm._s(String(twinDataState.value.value)) + "\n          ")])]) : _vm.getComponentType(twinDataState) === 'json' ? _c('div', {
      staticClass: "preview-text-container",
      on: {
        "click": function ($event) {
          return _vm.showJSON(twinDataState.value.value);
        }
      }
    }, [_c('div', {
      staticClass: "preview-text text-truncate",
      staticStyle: {
        "font-size": "24px"
      }
    }, [_vm._v("{ JSON }")])]) : _vm._e()], 2), _c('div', {
      staticStyle: {
        "display": "flex",
        "justify-content": "space-between"
      }
    }, [_c('div', {
      staticClass: "text-caption preview-tile-center",
      style: _vm.favCard ? 'font-size: 0.6rem !important; line-height: unset;' : ''
    }, [_c(VIcon, {
      class: _vm.color + '--text mr-1',
      attrs: {
        "small": ""
      },
      domProps: {
        "textContent": _vm._s(`fal fa-clock`)
      }
    }), _vm._v("\n          " + _vm._s(_vm.localizeDate((twinDataState.value || {}).time)) + "\n        ")], 1), !_vm.favCard ? _c(VIcon, {
      class: _vm.color + '--text mr-1',
      attrs: {
        "small": ""
      },
      domProps: {
        "textContent": _vm._s(`fal fa-calendar-alt`)
      },
      on: {
        "click": function ($event) {
          return _vm.showHistory(twinDataState);
        }
      }
    }) : _vm._e()], 1)]);
  })], 2) : _c('div', {
    staticClass: "ml-4 mr-4 pb-1"
  }, [_c(VRow, {
    attrs: {
      "justify": "start",
      "align": "center"
    }
  }, _vm._l(_vm.tiles, function (twinDataState) {
    return _c(VCol, {
      key: `state_${twinDataState.id}`,
      staticClass: "pa-1 ma-0"
    }, [_c(VCard, {
      staticClass: "dtwin-card",
      attrs: {
        "outlined": "",
        "elevation": "0"
      }
    }, [_c(VCardText, {
      staticClass: "pa-1"
    }, [_c('div', {
      staticClass: "text-caption text-truncate"
    }, [_vm._v(_vm._s(twinDataState.properties.title))]), twinDataState.properties.valueType === 'json' ? _c('div', {
      staticClass: "text-caption text-truncate fav-dbox-value"
    }, [_vm._v("\n              >> JSON\n            ")]) : _c('div', {
      staticClass: "text-caption text-truncate fav-dbox-value"
    }, [_vm._v("\n              " + _vm._s(twinDataState.value.value) + "\n              "), _c('span', {
      staticClass: "fav-dbox-unit"
    }, [_vm._v("\n                " + _vm._s(twinDataState.unit) + "\n              ")])])])], 1)], 1);
  }), 1)], 1), _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.showJsonDialog,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        _vm.showJsonDialog = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.jsonDetails')))];
      },
      proxy: true
    }])
  }, [_c('codemirror', {
    attrs: {
      "options": _vm.cmOptionsJson,
      "value": _vm.previewJsonData
    }
  })], 1), _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.showStringDialog,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        _vm.showStringDialog = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.stringDetails')))];
      },
      proxy: true
    }])
  }, [_c('codemirror', {
    attrs: {
      "options": _vm.cmOptionsString,
      "value": _vm.previewStringData
    }
  })], 1), _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.showHistoryDialog,
      "max-width": "95%"
    },
    on: {
      "close": function ($event) {
        _vm.showHistoryDialog = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.stateHistory')))];
      },
      proxy: true
    }])
  }, [_vm.showHistoryDialog && _vm.historyState ? _c('core-dtwin-state-history', {
    ref: "dtwin-state-history",
    attrs: {
      "state": _vm.historyState
    }
  }) : _vm._e()], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };